import { memo, useEffect, useState } from "react";
import { connect } from "react-redux";
import OrganizationSelector from "../../OrganizationSelector";
import NetworksSelector from "../../NetworksSelector";
import moment from "moment";
import axios from "axios";
import {
  API_URL,
  EXPORT_REPORTS_API_URL,
  FORMAT_DATE_API,
  NEW_API_URL,
  PAGE_SIZE,
  REPORTS_API_URL,
} from "../../../constants/Globals";
import IntervalSelector from "../../IntervalSelector";
import { numFormatter } from "../../../helpers/Number";
import InfiniteScroll from "react-infinite-scroll-component";
import { ArrowIcon, ChevronDownIcon, ChevronUpIcon } from "../../../icons";

const InfoStatsBox = memo(
  ({ title, slug, intervalDates, selectedNetworks, groupId = "" }) => {
    const [value, setValue] = useState(0);
    console.log('title------',title,slug);
    let params = {
      groupId: groupId,
      fromDate: intervalDates.start.format(FORMAT_DATE_API),
      toDate: intervalDates.end.format(FORMAT_DATE_API),
      clientIds: selectedNetworks.join(","),
    };

    let apiUrl = '';
    if (slug == 'iDsIssued') {
      apiUrl = `${NEW_API_URL}/master/uuid/total-issued`;
    } else if (slug == 'votesAccepted') {
      params.isAccepted = 1;
      apiUrl = `${NEW_API_URL}/master/votes-audit`;
    } else if (slug == 'votesBlocked') {
      params.isAccepted = 0;
      apiUrl = `${NEW_API_URL}/master/votes-audit`;
    }

    useEffect(() => {
      if (intervalDates.start < intervalDates.end) {
        axios
          .get(apiUrl, {
            params: params,
          })
          .then(({ data }) => {
            setValue(data.data);
          });
      }
    }, [intervalDates, slug, groupId, selectedNetworks]);

    const valueToDisplay = value !== 0 ? numFormatter(value?.totalCount) : 0;

    return (
      <div>
        <div className="info-stat-title">{title}</div>
        <div className="info-stat-value">
          {valueToDisplay}
          <>
            <ArrowIcon
              className={
                parseFloat(value?.statDifference?.totalCount) < 0
                  ? "change-down"
                  : "change-up"
              }
            />
            {/* <span>{Math.abs(changePercent).toFixed(1)}%</span> */}
          </>
        </div>
      </div>
    );
  }
);

function VotesAudit({ allNetworks = [], groups = [] }) {
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [selectedNetworks, setSelectedNetworks] = useState([]);
  const [groupNetworks, setGroupNetworks] = useState([]);
  const [intervalDates, setIntervalDates] = useState({
    start: moment().subtract(30, "days"),
    end: moment(),
  });

  /** It will display as tile above table */
  const infoStatsBoxes = [
    { title: "IDs Issued", slug: "iDsIssued",  },
    { title: "Votes Accepted", slug: "votesAccepted",  },
    { title: "Votes Blocked", slug: "votesBlocked",  },
  ];

  useEffect(() => {
    if (selectedGroup) {
      axios
        .get(
          `${API_URL}/admin/groups/getGroupNetworks?groupId=${selectedGroup}&pageNumber=1&perPage=100&order=asc&orderBy=name`
        )
        .then(({ data }) => {
          setGroupNetworks(data.data);
        });
    }
  }, [selectedGroup]);

  return (
    <>
      <div className="page-headline is-flex">
        <div>
          <strong>Reports</strong>&nbsp;|&nbsp;Votes Audit
        </div>
        <IntervalSelector
          startDate={intervalDates.start}
          endDate={intervalDates.end}
          onChange={(startDate, endDate) =>
            setIntervalDates({
              start: startDate,
              end: endDate,
            })
          }
        />
      </div>

      <div className="page-selectors">
        {groups?.length > 0 && (
          <OrganizationSelector
            value={selectedGroup}
            onChange={(id) => {
              setSelectedGroup(id);
              setSelectedNetworks([]);
              setGroupNetworks([]);
            }}
          />
        )}
        <NetworksSelector
          multiple={true}
          value={selectedNetworks}
          defaultText="All Networks"
          networks={selectedGroup ? groupNetworks : allNetworks}
          onChange={(ids) => setSelectedNetworks(ids)}
        />
      </div>

      <div>
        <div className="info-box">
          <div className="info-box-header">Last 30 days</div>
          <div className="info-box-content">
            <div className="info-stats">
              {infoStatsBoxes.map(({ title, slug }) => (
                <InfoStatsBox
                  intervalDates={intervalDates}
                  selectedNetworks={selectedNetworks}
                  groupId={selectedGroup}
                  title={title}
                  slug={slug}
                  key={slug}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
      <div>&nbsp;</div>
      
    </>
  );
}

const mapStateToProps = (state) => ({
  allNetworks: state.networks.networksList,
  groups: state.networks.groupsList,
});
// export default ReportsAiUsage;
export default connect(mapStateToProps, {})(VotesAudit);
